<script setup lang="ts">
import { Search } from 'lucide-vue-next';
</script>

<template>
  <UiCustomEmptyState
    class="py-8"
    tag="p"
    variant="neutral"
    :title="$t('components.results.noResults.title')"
    :description="$t('components.results.noResults.description')"
    title-class="text-3xl sm:text-4xl"
    description-class="text-sm sm:text-base text-text-secondary-600"
    inner-class="gap-2 sm:gap-4"
  >
    <template #icon>
      <Search class="h-4 w-4 sm:h-5 sm:w-5" />
    </template>
  </UiCustomEmptyState>
</template>
